import type {
	HandleFieldPayload,
	Handler,
	MutableRecordSource,
	RecordSourceProxy,
} from 'relay-runtime/lib/store/RelayStoreTypes';

const RELAY_DATA_ID_SEPARATOR = ':::::';

/**
 * Lets us delete records matching the ARI of the deleted item. We're matching all
 * instances of the ARI because:
 * - ARI uniquely represents a deleted entity
 * - we don't have typename information from this annotation
 */
export const createDeleteRecordHandler = (source: MutableRecordSource): Handler => ({
	update: (store: RecordSourceProxy, payload: HandleFieldPayload) => {
		const record = store.get(payload.dataID);
		if (record == null) {
			return;
		}

		const idOrIds = record.getValue(payload.fieldKey);
		const aris = Array.isArray(idOrIds) ? idOrIds : [idOrIds];

		const idsInStore = source.getRecordIDs();

		const arisToDelete = aris.flatMap((id) => {
			if (typeof id !== 'string') {
				return [];
			}

			const typeQualifiedPrefix = `${id}${RELAY_DATA_ID_SEPARATOR}`;
			const matchingStoreIDs = idsInStore.filter((dataID) =>
				dataID.startsWith(typeQualifiedPrefix),
			);

			return matchingStoreIDs;
		});

		arisToDelete.forEach((dataID) => store.delete(dataID));
	},
});
